exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html[data-v-38a929bb]{box-sizing:border-box}@media (min-width:901px){html[data-v-38a929bb]{font-size:130%}}@media (min-width:601px) and (max-width:900px){html[data-v-38a929bb]{font-size:120%}}@media (max-width:600px){html[data-v-38a929bb]{font-size:100%}}@media (max-width:350px){html[data-v-38a929bb]{font-size:100%}}[data-v-38a929bb],[data-v-38a929bb]:after,[data-v-38a929bb]:before{box-sizing:inherit}em[data-v-38a929bb]{font-style:italic}.cross[data-v-38a929bb]{cursor:pointer;position:fixed;z-index:10;top:1rem;right:1rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-38a929bb","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Cross.vue
// module id = 49
// module chunks = 0